module.exports = __webpack_public_path__ + "static/media/5-0.a992a8ba.jpg";